import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { ProjectChecklistItem } from '@portal-core/project-checklists/models/project-checklist-item.model';

@CollectionStateSelectors({
  stateType: ProjectChecklistItemsState
})
@State<ProjectChecklistItemsState>({
  name: ProjectChecklistItemsState.source
})
@Service({ autoProvided: false })
export class ProjectChecklistItemsState extends CollectionStateBase {
  static override source = 'ProjectChecklistItems';
  getSource(): string {
    return ProjectChecklistItemsState.source;
  }
}

@Service()
export class ProjectChecklistItemsDataService extends CollectionDataServiceBase<ProjectChecklistItem> {
  protected readonly stateType = ProjectChecklistItemsState;
}
